import React from 'react';
import logo from '../../../images/logo.white.svg';

/**
 * @typedef {object} LogoProps
 * @property {*} [height]
 * @property {*} [width]
 */

/**
 * @param {LogoProps} props
 */
const Logo = props => {
  const { height = 'auto', width = '100%' } = props;

  return (
    <div className='logo'>
      <img src={logo} alt='' height={height} width={width} />
    </div>
  );
};

export default Logo;
